import { useEffect, useRef } from 'react'
import { patchCartItemStatus } from 'tripPlanner/api/cartStatus'
import type { CartPanelItem } from './useCartPanelItems'

interface UseCartPanelReconciliationArgs {
  chatId: number | undefined
  items: Array<CartPanelItem>
  multiCartId: string | undefined
}

export function useCartPanelReconciliation({
  chatId,
  items,
  multiCartId,
}: UseCartPanelReconciliationArgs): void {
  const hasReconciledRef = useRef(false)
  const prevChatIdRef = useRef(chatId)

  useEffect(() => {
    if (prevChatIdRef.current !== chatId) {
      prevChatIdRef.current = chatId
      hasReconciledRef.current = false
    }
  }, [chatId])

  useEffect(() => {
    if (hasReconciledRef.current || !chatId || items.length === 0) return
    hasReconciledRef.current = true

    // K1: reconcileCartItems for not_synced items — deferred until BE endpoint ships
    // (POST /api/trips/v3/chats/:chatId/reconcile-cart was deferred from Phase 1)

    // K3: clear stale cartItemIds
    const staleCartItemIds = items
      .filter(i => i.cartItemId && i.source === 'itinerary')
      .map(i => ({ itemId: i.tripItemId, cartItemId: null as string | null }))

    if (staleCartItemIds.length > 0 && !multiCartId) {
      patchCartItemStatus(chatId, staleCartItemIds).catch(error => {
        console.warn('[cart-panel] Failed to clear stale cartItemIds', error)
      })
    }
  }, [chatId, items, multiCartId])
}
